// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3kn54","loaderOuter":"PageOverlayLoader_loaderOuter__3N-rk"};